import React from "react";
import { List, Datagrid, TextField, DateField } from "react-admin";

const EntityLocationsList: React.FC = () => (
  <List>
    <Datagrid>
      <TextField source="location.name" label="Location" />
      <TextField source="location.city.name" label="Ville" />
      <DateField
        source="created_at"
        label="Created At"
        options={{ year: "numeric", month: "long", day: "2-digit" }}
      />
    </Datagrid>
  </List>
);

export default EntityLocationsList;
